module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/login/forgot-password/forgot-password.component.scss
// module id = ./src/app/login/forgot-password/forgot-password.component.scss
// module chunks = main